import { HttpClient } from '@store/base';
import {
  GetGoodsNoticeInfoRequest,
  GetGoodsNoticeInfoResponse,
} from '../../model';

export class GetGoodsNoticeInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsNoticeInfoRequest) {
    return await this.httpClient.request<GetGoodsNoticeInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/infos/notice-info`,
    });
  }
}
